// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2MMW0","detailsBorder":"styles_detailsBorder__6VoUZ"};